import { Controller } from "react-hook-form";
import {
  TextField,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Vocabulary } from "../../Utils/Vocabulary";

interface VideoUploadFieldProps {
  control: any;
  fields: any[];
  append: (value: any) => void;
  remove: (index: number) => void;
}

export default function VideoUploadField({
  control,
  fields,
  append,
  remove,
}: VideoUploadFieldProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h5">{Vocabulary.videoCourse}</Typography>
      {fields.map((item, index) => (
        <Box
          key={item.id}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 1.5,
            p: 1.5,
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            background: "#fafbfc",
            boxShadow: 1,
          }}
        >
          <Controller
            name={`videos.${index}.iframe`}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label={Vocabulary.video || "Video"}
                fullWidth
                margin="none"
                error={!!error}
                helperText={error?.message}
                variant="outlined"
                sx={{ flex: 1 }}
                multiline
                minRows={1}
                maxRows={6}
                inputProps={{ style: { resize: "vertical" } }}
              />
            )}
          />
          <Tooltip title={Vocabulary.delete}>
            <IconButton size="large" onClick={() => remove(index)} color="error">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ))}
      <Button
        onClick={() => append({ iframe: "" })}
        color="primary"
        variant="contained"
        size="large"
        sx={{
          mt: 2,
          borderRadius: 2,
          fontWeight: 600,
          textTransform: "none",
          boxShadow: 1,
          fontSize: "0.9rem",
        }}
        fullWidth
      >
        {Vocabulary.addVideo}
      </Button>
    </Box>
  );
}
